import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';



import Divider from '@material-ui/core/Divider';

import { Link } from 'react-router-dom';

import BackIcon from '@material-ui/icons/ChevronLeft';
import { Redirect } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import LessonComp from "../components/LessonComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import * as STATIC from '../config/static';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import TopBar from '../components/TopBar';
import SorobanComp from '../components/SorobanComp';
const defaultSetting = {
  type: [],
  rows: 3,
  showTime: 6,
  answerTime: 6,
  qCount: 5,
  maxNumber: 10,
  digits: 1,
  digits1: 1,
  digits2: 1,
  displaySetting: 0,
  displayShow: 0,
  lessThan0: 0,
  isReversed:0
}



let _this;
let formulars = [
  {name:'FLASHCARD',childs:[]},
  {name:'DIRECT',childs:[]},
  {name:'LITTLE BUDDY +',childs:[
      {name:'LB + 4',formular:'LB_4',group:5,number:4,type:'LB+'},
      {name:'LB + 3',formular:'LB_3',group:5,number:3,type:'LB+'},
      {name:'LB + 2',formular:'LB_2',group:5,number:2,type:'LB+'},
      {name:'LB + 1',formular:'LB_1',group:5,number:1,type:'LB+'}
    ]},
    {name:'LITTLE BUDDY -',childs:[
        {name:'LB - 4',formular:'LB_-4',group:5,number:4,type:'LB-'},
        {name:'LB - 3',formular:'LB_-3',group:5,number:3,type:'LB-'},
        {name:'LB - 2',formular:'LB_-2',group:5,number:2,type:'LB-'},
        {name:'LB - 1',formular:'LB_-1',group:5,number:1,type:'LB-'}
      ]},

  {name:'BIG BUDDY +',childs:[
    {name:'BB + 9',formular:'BB_9.1',group:10,number:9,type:'BB+'},
    {name:'BB + 8',formular:'BB_8.1',group:10,number:8,type:'BB+'},
    {name:'BB + 7',formular:'BB_7.1',group:10,number:7,type:'BB+'},
    {name:'BB + 6',formular:'BB_6.1',group:10,number:6,type:'BB+'},
    {name:'BB + 5',formular:'BB_5.1',group:10,number:5,type:'BB+'},
    {name:'BB + 4',formular:'BB_4.1',group:10,number:4,type:'BB+'},
    {name:'BB + 3',formular:'BB_3.1',group:10,number:3,type:'BB+'},
    {name:'BB + 2',formular:'BB_2.1',group:10,number:2,type:'BB+'},
    {name:'BB + 1',formular:'BB_1.1',group:10,number:1,type:'BB+'},
    ]},
    {name:'LITTLE BUDDY & BIG BUDDY +',childs:[
        {name:'L&B + 9',formular:'L&B_9.2',group:10,number:9,type:'L&B+'},
        {name:'L&B + 8',formular:'L&B_8.2',group:10,number:8,type:'L&B+'},
        {name:'L&B + 7',formular:'L&B_7.2',group:10,number:7,type:'L&B+'},
        {name:'L&B + 6',formular:'L&B_6.2',group:10,number:6,type:'L&B+'}
      ]},
    {name:'BIG BUDDY -',childs:[
      {name:'BB - 9',formular:'BB_-9.1',group:10,number:9,type:'BB-'},
      {name:'BB - 8',formular:'BB_-8.1',group:10,number:8,type:'BB-'},
      {name:'BB - 7',formular:'BB_-7.1',group:10,number:7,type:'BB-'},
      {name:'BB - 6',formular:'BB_-6.1',group:10,number:6,type:'BB-'},
      {name:'BB - 5',formular:'BB_-5.1',group:10,number:5,type:'BB-'},
      {name:'BB - 4',formular:'BB_-4.1',group:10,number:4,type:'BB-'},
      {name:'BB - 3',formular:'BB_-3.1',group:10,number:3,type:'BB-'},
      {name:'BB - 2',formular:'BB_-2.1',group:10,number:2,type:'BB-'},
      {name:'BB - 1',formular:'BB_-1.1',group:10,number:1,type:'BB-'},
      ]},

        {name:'LITTLE BUDDY & BIG BUDDY -',childs:[
            {name:'L&B - 9',formular:'L&B_-9.2',group:10,number:9,type:'L&B-'},
            {name:'L&B - 8',formular:'L&B_-8.2',group:10,number:8,type:'L&B-'},
            {name:'L&B - 7',formular:'L&B_-7.2',group:10,number:7,type:'L&B-'},
            {name:'L&B - 6',formular:'L&B_-6.2',group:10,number:6,type:'L&B-'}
          ]},{name:'MULTIPLE',childs:[]},{name:'DIVIDE',childs:[]},
]
let fTextList = {
  'LB+':[
    'LB + 4 = +5 - 1',
    'LB + 3 = +5 - 2',
    'LB + 2 = +5 - 3',
    'LB + 1 = +5 - 4',
  ],
  'LB-':[
    'LB - 4 = -5 + 1',
    'LB - 3 = -5 + 2',
    'LB - 2 = -5 + 3',
    'LB - 1 = -5 + 4',
  ],
  'BB+':[
    'BB + 9 = +10 - 1',
    'BB + 8 = +10 - 2',
    'BB + 7 = +10 - 3',
    'BB + 6 = +10 - 4',
    'BB + 5 = +10 - 5',
    'BB + 4 = +10 - 6',
    'BB + 3 = +10 - 7',
    'BB + 2 = +10 - 8',
    'BB + 1 = +10 - 9',
  ],
  'L&B+':[
    'L&B + 9 = +10 - 5 + 4',
    'L&B + 8 = +10 - 5 + 3',
    'L&B + 7 = +10 - 5 + 2',
    'L&B + 6 = +10 - 5 + 1',],
  'BB-':[
    'BB - 9 = -10 + 1',
    'BB - 8 = -10 + 2',
    'BB - 7 = -10 + 3',
    'BB - 6 = -10 + 4',
    'BB - 5 = -10 + 5',
    'BB - 4 = -10 + 6',
    'BB - 3 = -10 + 7',
    'BB - 2 = -10 + 8',
    'BB - 1 = -10 + 9',
  ],

    'L&B-':[
      'L&B - 9 = -10 + 5 - 4',
      'L&B - 8 = -10 + 5 - 3',
      'L&B - 7 = -10 + 5 - 2',
      'L&B - 6 = -10 + 5 - 1',],
}
const DWIDTH = 980;

class Lessons extends Component {
  constructor() {
    super();
    _this = this;
    this.state = {showSoroban:false,startedInterval:false, wWidth: 0, wHeight: 0, message: '',cType:0,showFormula:0,showChild:false,showGroup:false,showFText:false,eIndex:0,eNumbs:[],VIDEOS:[],showResultDetail:false,result:{}};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });


  }

  componentDidMount() {

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);


  this.setState({  loading: false });

  }

  componentWillUnmount() {
    if(_this.interval)
    {
      clearInterval(_this.interval);
    }
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  showVideo(){
    _this.setState({showVideo:true});
    _this.loadVideo();
  }
  async loadVideo(){
    let data = await firebase.firestore().collection('videos').orderBy('order').get();
    let VIDEOS =[];
    if (data.size>0) {
      data.forEach((doc)=>{
        let item = doc.data();
        item.id = doc.id;
        VIDEOS.push(item);
      })
    }
    _this.setState({VIDEOS});
  }
  handleChangeDigits = (name,max) => event => {

    let value = event.target.value;
    if(value=='')
{
  value=0;
}
    if(!parseInt(value) && value!='')
    {
      this.forceUpdate();
      return;
        }
        value=parseInt(value);
    if(value>max)
    {
      value=max;
    }

    this.setState({
      [name]: value
    });

  };

  selectFormula(index)
  {

    if(formulars[index].childs.length>0)
    {
      _this.setState({fIndex:index,showChild:formulars[index].childs});

    }
    else {
      let formular = _.cloneDeep(defaultSetting);
      let f = 'LB_0';

      formular.type=[f];
      formular.digits = 1;
      formular.minDigits = 1;
      formular.maxDigits = 2;
      formular.roundNumber = 0;
      formular.showTypeText=_this.state.showGroup.name;
      formular.displaySetting = 1;
      if(index==0)
      {
        if(_this.state.showFormula==1)
        {
          formular.type=['image'];
          formular.roundNumber = 1;
          formular.digits = 2;
        }
        if(_this.state.showFormula==2)
        {
          formular.type=['soroban'];
          formular.maxDigits = 5;
        }
      }
      if(index==8)
      {
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 6;
        formular.digits1 = 2;
        formular.digits2 = 2;
        formular.roundNumber = 0;
        formular.type=['multiple'];
        formular.showType=3;
        formular.showTypeText='X';
        formular.showTypeImage = 'assets/web/icon_super_multi.png';
        formular.group='Multi';
        _this.setState({showFText:false,showGroup:false,showFormula:false,showLesson:true,showExample:false,formular,sType:{name:'Multiple',type:formular.type[0],group:5},eIndex:0,eChildIndex:0,eNumbs,fDigit:0});

        return;
      }
      if(index==9)
      {
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 6;
        formular.digits1 = 2;
        formular.digits2 = 2;
        formular.roundNumber = 0;
        formular.type=['divide'];
        formular.showType=3;
        formular.showTypeText='/';
        formular.showTypeImage = 'assets/web/icon_super_divide.png';
        formular.group='Divide';
        _this.setState({showFText:false,showGroup:false,showFormula:false,showLesson:true,showExample:false,formular,sType:{name:'Divide',type:formular.type[0],group:5},eIndex:0,eChildIndex:0,eNumbs,fDigit:0});

        return;
      }
      let eNumbs = _this.generateExample(0,formular.type[0]);
      _this.setState({showFText:false,showGroup:false,showFormula:false,showLesson:true,showExample:true,formular,sType:{name:index==0?'Flashcard':'Direct',type:formular.type[0],group:5},eIndex:0,eChildIndex:0,eNumbs,fDigit:0});
      if(formular.type[0]=="LB_0")
      {
        //_this.startInterval();
      }
    }
  }
  startInterval()
  {
    if(_this.interval)
    {
      clearInterval(_this.interval);
    }
    _this.setState({startedInterval:true})
    _this.interval = setInterval(function(){
      let {eChildIndex,eIndex,eNumbs} = _this.state;
      if(eChildIndex<eNumbs[eIndex].numbs.length-1)
      {
        _this.setState({eChildIndex:eChildIndex+1});
      }
      else {
        _this.setState({eChildIndex:0});
      }
    },1500);
  }
  selectChildFormula(index)
  {
    console.log("selectChildFormula");
    if(_this.state.cType==1)
_this.setState({cIndex:index,showChild:false,showGroup:_this.state.showChild[index]});
else
{
  let type = _this.state.showChild[index].type;
  _this.setState({cIndex:index,showChild:false,showGroup:_this.state.showChild[index]},()=>_this.skipInGroup(type,true))
}

  }



  backClick() {
    if(_this.interval)
    {
      clearInterval(_this.interval);
    }
_this.setState({showFText:false,startedInterval:false});
    //console.log(_this.state.showVideo);
    if(_this.state.showVideo)
    _this.setState({showVideo:false});
    else if(_this.state.showExample)
    _this.setState({showExample:false});
    else if(_this.state.showLesson)
    _this.setState({showLesson:false});
    else
        _this.props.history.push("/");

  }
  onLessonEnd(questions) {
    //console.log(questions);
    let count = 0;
    let countCorrect = 0;
    for (let q of questions) {
      if (q.status) {
        count++;
        if (q.status == 1) {
          countCorrect++;
        }
      }
    }

    // if(count==countCorrect&&count==questions.length)
    // {
    //   _this.setState({showSignUp:true});
    // }

    let percent = Math.round(countCorrect / questions.length * 100);
    let ACCOUNT = store.getState().ACCOUNT;
    let nResult = {questions,percent,countCorrect,qlength: questions.length,group:questions.group?questions.group:''};
    if(ACCOUNT.type==0)
    nResult.id_student=ACCOUNT.id;
    if(ACCOUNT.type==1)
    nResult.id_teacher=ACCOUNT.id;

    _this.setState({ showResultDetail: true,result:{percent,group:questions.group?questions.group:'',countCorrect,qlength: questions.length,questions} });
  }

generateExample(number,type)
{
  let numbers = [];
  if(type=='image')
  {
    let Arr = [0,1,2,3,4,5,6,7,8,9,10,20,30,40,50,60,70,80,90];
    for(let n of Arr)
    {
      let item = {name:n,image:'assets/images/finger/'+n+'-01.png',numbs:[n]};
      numbers.push(item);
    }
  }
  if(type=='soroban')
  {
    const { wWidth, wHeight,showLesson} = this.state;
    let width = DWIDTH;
    if (wWidth < DWIDTH) {
      width = wWidth;
    }
    let sRate = 640 / 1010;
    if (showLesson) {
      sRate = 980 / 640;
    }
    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    let Arr = [0,1,2,3,4,5,6,7,8,9,10,20,30,40,50,60,70,80,90];
    for(let n of Arr)
    {
      let item = {name:n,image:_this.getSorobanImages(n,width),numbs:[n]};
      numbers.push(item);
    }
  }
  if(type=='LB_0')
  {
    let Arr = [0,1,2,3,4,5,6,7,8,9];
    for(let n of Arr)
    {
      for(let l of Arr)
      {
        if(!_this.checkLB(n,l)&&!_this.checkBB(n,l))
        {
          let item = {name:n+' + '+l,image:'',numbs:[n,n+l]};
          numbers.push(item);
        }
      }


    }
  }
  if(type=='LB+')
  {
    let Arr = [0,1,2,3,4,5,6,7,8,9];
    //_.reverse(Arr);
    for(let n of Arr)
    {
      if(_this.checkLB(n,number))
      {
        let item = {name:n+' + '+number,image:'',numbs:[n,n+5,n+5-(5-number)]};
        numbers.push(item);
      }

    }
  }
  if(type=='LB-')
  {
    let Arr = [0,1,2,3,4,5,6,7,8,9];
    //_.reverse(Arr);
    for(let n of Arr)
    {
      if(_this.checkLB(n,number*-1))
      {
        let item = {name:n+' - '+number,image:'',numbs:[n,n-5,n-5+(5-number)]};
        numbers.push(item);
      }

    }
  }
  if(type=='BB+')
  {
    let Arr = [0,1,2,3,4,5,6,7,8,9];
    //_.reverse(Arr);
    for(let n of Arr)
    {
      if(_this.checkBB(n,number)&&!_this.checkLAB(n,number))
      {
        let item = {name:n+' + '+number,image:'',numbs:[n,n+10,n+10-(10-number)]};
        numbers.push(item);
      }

    }
  }
  if(type=='BB-')
  {
    let Arr = [10,11,12,13,14,15,16,17,18,19];
    //_.reverse(Arr);
    for(let n of Arr)
    {
      if(_this.checkBB(n,number*-1)&&!_this.checkLAB(n,number*-1))
      {
        let item = {name:n+' - '+number,image:'',numbs:[n,n-10,n-10+(10-number)]};
        numbers.push(item);
      }

    }
  }
  if(type=='L&B+')
  {
    let Arr = [0,1,2,3,4,5,6,7,8,9];
    //_.reverse(Arr);
    //console.log(number);
    for(let n of Arr)
    {
      if(_this.checkLAB(n,number))
      {
        let item = {name:n+' + '+number,image:'',numbs:[n,n+10,n+10-5,n+10-5+(number-5)]};
        numbers.push(item);
      }
    }
  }
  if(type=='L&B-')
  {

    let Arr = [10,11,12,13,14,15,16,17,18,19];
    //_.reverse(Arr);
    for(let n of Arr)
    {
      if(_this.checkLAB(n,number*-1))
      {
        let item = {name:n+' - '+number,image:'',numbs:[n,n-10,n-10+5,n-10+5+(5-number)]};
        numbers.push(item);
      }
    }
  }
//  console.log(numbers);

  return numbers;
}

generateImages(number,row,width,image)
{
  let rel = [];
  let items = [];
  let key = 0;
  for(let i = 1;i<=number;i++)
  {
    if(i%row!=0)
    {
      items.push(<img key={i} src={'assets/web/'+image} style={{width}} />);

    }
    else {
      items.push(<img key={i} src={'assets/web/'+image}  style={{width}} />);
      rel.push(<div key={key} style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>{items}</div>);
      key++;
      items = [];
    }

}
if(items.length>0)
{
rel.push(<div key={key} style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>{items}</div>);
}
return rel;
}

nextExample()
{
    let {eIndex,eNumbs} = _this.state;
    if(eIndex<eNumbs.length-1)
    {
      eIndex++;
    }
    else {
      eIndex=0;
    }
    //console.log(eIndex);
    _this.setState({eIndex,eChildIndex:0});
}

skipInGroup(type,skip=false)
{
  if(!_this.state.showFText&&skip==false)
  {
    _this.setState({showFText:type});
  }
  else {
    let formular = _.cloneDeep(defaultSetting);
  //  console.log(_this.state.showGroup);
    formular.type=[_this.state.showGroup.formular];
    formular.digits = 1;
    formular.minDigits = 1;
    formular.maxDigits = 2;

    formular.roundNumber = 0;
formular.showTypeText=_this.state.showGroup.name;
  formular.displaySetting = 1;
  formular.isReversed = _this.state.cType==2?1:0;
  let eNumbs = _this.generateExample(_this.state.showGroup.number,_this.state.showGroup.type);

    _this.setState({showFText:false,showGroup:false,showFormula:false,showLesson:true,formular,sType:_this.state.showGroup,eNumbs,eIndex:0,eChildIndex:0});
  //  _this.startInterval();
  }
}
skipEx(){
  let {eChildIndex,eIndex,eNumbs} = _this.state;
  if(eChildIndex<eNumbs[eIndex].numbs.length-1)
  {
    _this.setState({eChildIndex:eChildIndex+1});
  }
  else {
    _this.setState({eChildIndex:0});
  }
}
getSorobanImages(numb,width){
  let tArr = numb.toString().split('');
  let bWidth = width*0.7/5;
  //let n=6;
  let bStyle = {width:bWidth,height:bWidth*0.53}
  let rel= (<div style={{display:'flex',flexDirection:'row'}}>
    {tArr.map((n,index)=>{
      return (<div key={index} style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>

        <div style={bStyle}>
          {n>=5?<img
              src="assets/images/soroban/soroban.png"
              style={bStyle} />:false}
        </div>
        <div
          style={{position: 'relative',lineHeight:0}}>
          <img
          src="assets/images/soroban/sline.png"
          style={{width: bWidth, height: bWidth*0.11}} />
        {index==tArr.length-1?<div style={{position: 'absolute', top: 0, width: '100%', textAlign: 'center'}}>
          <img
          src="assets/images/soroban/dot.png"
          style={{width: 'auto', height: bWidth*0.078}} />
      </div>:false}
          </div>
          <div style={bStyle}>
            {n%5>=1?<img
                src="assets/images/soroban/soroban.png"
                style={bStyle} />:false}
          </div>
          <div style={bStyle}>
            {n%5>=2?<img
                src="assets/images/soroban/soroban.png"
                style={bStyle} />:false}
          </div>
          <div style={bStyle}>
            {n%5>=3?<img
                src="assets/images/soroban/soroban.png"
                style={bStyle} />:false}
          </div>
          <div style={bStyle}>{n%5>=4?<img
              src="assets/images/soroban/soroban.png"
              style={bStyle} />:false}
          </div>


      </div>);
    })}
  </div>);


return rel;

}
checkLB(t, value) {
  t=t%10;
  if (t > 0 && t < 5 && value > 0 && value < 5 && t + value >= 5 && t + value < 10) {
    return true;
  }
  if (t >= 5 && t < 10 && t + value > 0 && t + value < 5 && value > -5) {
    return true;
  }
  return false;
}
checkBB(t, value) {
  if (t > 0 && (t % 10) + value >= 10) {
    return true;
  }
  if (_this.state.lessThan0) {
    if (t >= 0 && t < 10 && t + value < 0) {
      return true;
    }
  }
  else {
    if (t >= 10 && (t % 10) + value < 0) {
      return true;
    }
  }

  return false;
}
checkLAB(t, value) {
  if(_this.checkBB(t,value))
  {

      if (value > 5) {
    if (_this.checkLB(t, (-10 + value))) {
      return true;
    }
  }
  else if(value<-5)
  {
    //console.log('LB-',t,(10 + value));
    if (_this.checkLB(t, (10 + value))) {
      return true;
    }
  }

  }

  return false;
}
getQuestionEQ(question,width)
{
  let rel = '';
  if(question.type!="image"&&question.type!="soroban")
  {

    for(let num of question.numbers)
    {
      if(question.type!='multiple'&&question.type!='divide')
      {
        if(rel=='')
        {
          rel=num;
          continue;
        }
        else {
          rel += (num>=0?' + ':' - ')+Math.abs(num);
        }
      }
      else {
        if(rel=='')
        {
          rel+=num;
        }
        else {
          rel+=""+num;
        }
      }

    }
  }
  else
  if(question.type=="soroban")
  {
   rel =   (<div style={{display:'inline-block'}}><img
  src={"assets/images/soroban/soroban.png"}
  style={{width: STATIC.calSize(30, STATIC.DWIDTH, width), height: 'auto'}} />


  </div>)
  }
  else {
    rel = (<div style={{display:'inline-block'}}>{question.images.map((i,index)=>{
      return (<img key={"image"+index}
  src={i}
  style={{width: STATIC.calSize(30, STATIC.DWIDTH, width), height: 'auto'}} />)
    })}

    </div>)
  }
  return rel;
}
generateLessonImages(numb,type='image',group=5){
  if(!numb || numb=='')
  numb=0;
  const { wWidth, wHeight,showLesson,showExample} = this.state;
  let width = DWIDTH;
  if (wWidth < DWIDTH) {
    width = wWidth;
  }
  let sRate = 640 / 1010;
  if (showLesson) {
    sRate = 980 / 690;
  }
  if (width / wHeight > sRate) {
    width = wHeight * sRate;
  }
  if(showExample)
  {
    let eRate = 920/1005;
    if (width / wHeight > eRate) {
      width = wHeight * eRate;
    }
  }
//console.log(type);
  if(type=='image')
  if(numb<10&&group==5)
  return <img src={'assets/images/finger/'+numb+'-01.png'} style={{ width: width * 0.3 }} />
  else
  return [<img src={'assets/images/finger/'+Math.floor(numb/10)+'0-01.png'} style={{ width: width * 0.3 }} />,<img src={'assets/images/finger/'+numb%10+'-01.png'} style={{ width: width * 0.3 }} />]
  else {
    return _this.getSorobanImages(numb,width);
  }
}
onChangeFormula (formular) {
  console.log(formular);
    _this.setState({formular})
}
  render() {
    const { classes,t } = this.props;
    const {showSoroban, wWidth, wHeight,title,showChild,fIndex,showGroup,showFText,showLesson,sType,showExample,eIndex,eNumbs,eChildIndex,cType,showVideo,VIDEOS,showVideoDetail,fDigit,showResultDetail,result,startedInterval} = this.state;
    let width = DWIDTH;

    let width2 = wWidth*0.4;
    if (wWidth < DWIDTH||showSoroban) {
      width = wWidth;
      console.log(width)
    }

    if(width2<width)
    {
      width2 = width;
    }

    let sRate = 640 / 1010;
    if (showLesson) {
      sRate = 980 / 690;
       //if(wWidth<600)
       //sRate = 600 / 1115;
    }
    if (showSoroban) {
      sRate = 1000 / 560;
       //if(wWidth<600)
       //sRate = 600 / 1115;
    }
    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let bRate = 391 / 271;

    let bWidth = width / 2;

    let video_wrapper = STATIC.calSize(600, STATIC.DWIDTH, width);
    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
    if(showSoroban)
    {
      console.log(width);
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <TopBar width={width} />
                    <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
                      <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

                        <div style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                          <div style={{ display: 'flex' }}>
                            <ButtonBase
                              focusRipple
                              onClick={() => this.setState({showSoroban:false})}
                              style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                              <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                            </ButtonBase>
                            <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>Soroban {sType?sType.name:""}</div>
                          </div>
                          <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
                        </div>

                        <SorobanComp formular={this.state.formular} width={width} />

                      </div>

          </div>
        </div></div>)
    }
    if(showVideo)
    {
      return (
        <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
          <div className={classes.middle}>
  <TopBar width={width} />
            <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
              <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

                <div style={{ marginBottom: STATIC.calSize(30, STATIC.DWIDTH, width) }}>
                  <div style={{ display: 'flex' }}>
                    <ButtonBase
                      focusRipple
                      onClick={() => this.backClick()}
                      style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                      <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                    </ButtonBase>
                    <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>VIDEOS</div>
                  </div>
                  <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
                </div>

                <div style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),height:STATIC.calSize(750, STATIC.DWIDTH, width)}}>
                  <Grid container direction="row" alignItems="center" justify="center" >




                    {VIDEOS.map((v,index)=>{
                      return (<Grid key={index} item xs={6} style={{display:'flex',justifyContent:'center', marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                        <ButtonBase onClick={()=>this.setState({showVideoDetail:v})}  focusRipple style={{ position:'relative', display: 'inline-block', width: width*0.4}} color="primary" size="large" variant="contained"  >
                          <video style={{width: video_wrapper*0.4,height: video_wrapper*0.4*9/16}} src={v.link} poster />
                          <div >{v.name}</div>
                        </ButtonBase>

                      </Grid>)
                    })}




                  </Grid>
                </div>

              </div>

            </div>


          </div>
          <Modal styles={{overlay:{padding:0}, modal: { minWidth: width, textAlign: 'center', background: 'none', boxShadow: 'none', color: "white",padding:0 } }} showCloseIcon={true} focusTrapped={false} open={showVideoDetail} onClose={() => this.setState({ showVideoDetail: false })} center>
            <video style={{width: width}} src={showVideoDetail?showVideoDetail.link:false} poster controls />
          </Modal>
        </div>);
    }
    if(showExample)
    {
      let eRate = 920/1005;
      if (width / wHeight > eRate) {
        width = wHeight * eRate;
      }
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

              <div style={{ marginBottom: STATIC.calSize(30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{sType.name}</div>
                </div>
                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
              </div>
              <Grid container  justify="center" style={{ marginTop: 5 }}>
                <Grid item xs={12} >
                  <Grid container alignItems="center" justify="center" style={{ border: 2, borderRadius: 10, width: '100%', height: width * 0.8, backgroundColor: "#65a343", position: 'relative' }} >
                    <div style={{ position: 'absolute', width: '100%', top: STATIC.calSize(5, STATIC.DWIDTH, width), left: STATIC.calSize(5, STATIC.DWIDTH, width) }}>
                      <img
                        src="assets/web/logo_trans.png"
                        style={{ maxWidth: 296, height: 'auto', width: STATIC.calSize(160, STATIC.DWIDTH, width) }} />
                    </div>
                    <Grid item  style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
{sType.type!='image'&&sType.type!='soroban'?<div style={{width:width*0.2,marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'white',color:'#053F22',fontSize:fNormal,textAlign:'center'}}>Ex: <br/>{eNumbs[eIndex].name}</div>:false}
                      <div>{sType.type=='image'?this.generateLessonImages(fDigit):sType.type=='soroban'?this.generateLessonImages(fDigit,'soroban',10):this.generateLessonImages(eNumbs[eIndex].numbs[eChildIndex],cType==1?'image':'soroban',sType.group)}</div>
                      <div style={{padding:STATIC.calSize(5, STATIC.DWIDTH, width)+'px '+STATIC.calSize(15, STATIC.DWIDTH, width)+'px',marginTop: STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'#EFE7AB',color:'#053F22',fontSize:fNormal,textAlign:'center'}}>{sType.type=='image'||sType.type=='soroban'?fDigit:eNumbs[eIndex].numbs[eChildIndex]}</div>
                        {false&&sType.type!='image'&&sType.type!='soroban'?<Button onClick={()=>this.skipEx()} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                          {t('common.skip')}
                        </Button>:false}
                        {sType.type!='image'&&sType.type!='soroban'?<div style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#fdce07", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                          {(eChildIndex+1)}/{eNumbs[eIndex].numbs.length}
                        </div>:false}
                        {startedInterval==true?true:<Button onClick={()=>this.startInterval()} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                          {t('common.start')}
                        </Button>}
                  </Grid>

                  </Grid>


                </Grid>
                <Grid item xs={12}  style={{marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}}>
                  <Grid container direction='row' style={{ marginTop: 5 }}>
                    <Grid item xs={8} >
                      {sType.type!='image'&&sType.type!='soroban'?<ButtonBase
                        focusRipple style={{ color: "#053f22",minWidth: 0 }} color="primary" size="medium" variant="contained" onClick={() => this.nextExample()}>
                        <img
                          src="assets/web/icon_l_next.png"
                          style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                      </ButtonBase>
                      :false}
                      {sType.type!='image'&&sType.type!='soroban'?<ButtonBase
                        focusRipple style={{ color: "#053f22",minWidth: 0,marginLeft:STATIC.calSize(10, STATIC.DWIDTH, width) }} color="primary" size="medium" variant="contained" onClick={() => this.setState({showSelectEx:true})}>
                        <img
                          src="assets/web/icon_l_select.png"
                          style={{ height: 'auto', width: STATIC.calSize(35, STATIC.DWIDTH, width) }} />

                      </ButtonBase>:false}
                      {sType.type=='image'||sType.type=='soroban'?(<div style={{flex:1}}>
                      <input ref={(input) => { this.answerInput = input; }} type="tel" onKeyPress={this.handleKeypress} onChange={this.handleChangeDigits("fDigit",sType.type=='image'?99:9999)} value={fDigit} style={{ width:width*0.2, textAlign: 'center', backgroundColor: "white", border: "1px #053f1e solid",
                          borderRadius: "4px", height: STATIC.calSize(50, STATIC.DWIDTH, width), marginRight: STATIC.calSize(10, STATIC.DWIDTH, width) }} /></div>):false}
                      </Grid>
                      <Grid item xs={4} style={{textAlign:'right'}} >
                        <Button style={{ color: "white", padding: (STATIC.calSize(2, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(6, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#65A343', fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showExample: false })}>
                          {t('common.more')}
                        </Button>
                        </Grid>
                    </Grid>
                  </Grid>
              </Grid>


            </div>
          </div>
        </div>
        <Modal styles={{ modal: { minWidth: width * 0.8, textAlign: 'center', background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={this.state.showSelectEx} onClose={() => this.setState({ showSelectEx: false})} center>
          <div style={{ width: width * 0.8, backgroundColor: 'rgba(141, 198, 63, 0.8)', position: 'relative', borderRadius: 10, padding: 10 }}>

            <fieldset style={{ borderColor: 'white', borderRadius: 10 }}>
                <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fTitle, color: 'rgb(5, 63, 34)' }}>{sType.name}</legend>
                  <Grid container direction='column' alignItems="center" justify="center" style={{paddingTop:STATIC.calSize(20, STATIC.DWIDTH, width),paddingBottom:STATIC.calSize(20, STATIC.DWIDTH, width) }} >
                    {eNumbs.map((f,index)=>{
                      return (<Grid key={index} item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                        <ButtonBase onClick={()=>this.setState({eIndex:index,showSelectEx:false})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative', display: 'flex', width: width*0.4,height:STATIC.calSize(40, STATIC.DWIDTH, width) ,backgroundColor:index!=eIndex?'white':'#fdce07', }} color="primary" size="large" variant="contained"  >

                          <div style={{fontSize:fNormal}}>{f.name}</div>
                        </ButtonBase>

                      </Grid>)
                    })}

                    </Grid>
                </fieldset>
            </div>
          </Modal>
      </div>);
    }

    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          {!showLesson&&<Link to={'/'} style={{ position: "fixed", width: "100%", bottom: 5, left: 5 }}>
            <img src="assets/web/logo_trans.png" style={{ width: STATIC.calSize(189, STATIC.DWIDTH, width), height: "auto" }} />
          </Link>}
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

              <div style={{ marginBottom: STATIC.calSize(30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{showLesson?sType.name:t('common.lessons')}</div>
                </div>
                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
              </div>
              {showLesson&&sType.name!="Divide"&&sType.name!="Multiple"?<Button style={{ color: "white", padding: (STATIC.calSize(2, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(6, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#65A343', fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showExample: true },()=>{/*this.startInterval()*/})}>
                {t('common.example')}
              </Button>:false}
              {showLesson&&sType.type!='soroban'&&_this.state.cType==2?<Button style={{marginLeft: STATIC.calSize(10, STATIC.DWIDTH, width), color: "white", padding: (STATIC.calSize(2, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(6, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#65A343', fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.setState({ showSoroban: true },()=>{/*this.startInterval()*/})}>
                SOROBAN
              </Button>:false}
              {!showLesson?<div style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),height:STATIC.calSize(750, STATIC.DWIDTH, width)}}>
                <Grid container direction="column" alignItems="center" justify="center" >
                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({showFormula:1,cType:1})} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_l_finger.png"} style={{ width: bWidth }} />

                    </ButtonBase>

                  </Grid>
                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({showFormula:2,cType:2})}  focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_l_super.png"} style={{ width: bWidth }} />


                    </ButtonBase>

                  </Grid>


                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.showVideo()}  focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_l_video.png"} style={{ width: bWidth }} />

                    </ButtonBase>

                  </Grid>


                </Grid>
              </div>:false}
              {showLesson ? <LessonComp
                {...this.state.formular}
                showAdvance={false}
                updateTitle={(title)=>this.setState({title})}
                onLessonEnd={this.onLessonEnd}
                onChangeFormula={this.onChangeFormula}
                pWidth={width}
              /> : false}

            </div>

          </div>


        </div>
        <Modal styles={{ modal: { minWidth: width * 0.8, textAlign: 'center', background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={this.state.showFormula} onClose={() => this.setState({ showFormula: false,showChild:false })} center>
          <div style={{ width: width * 0.8, backgroundColor: 'rgba(141, 198, 63, 0.8)', position: 'relative', borderRadius: 10, padding: 10 }}>
            {!showChild?<fieldset style={{ borderColor: 'white', borderRadius: 10 }}>
              <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fTitle, color: 'rgb(5, 63, 34)' }}>Formula</legend>
                <Grid container direction='column' alignItems="center" justify="center" style={{paddingTop:STATIC.calSize(20, STATIC.DWIDTH, width),paddingBottom:STATIC.calSize(20, STATIC.DWIDTH, width) }} >
                  {formulars.map((f,index)=>{
                    return (<Grid key={index} item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <ButtonBase onClick={()=>this.selectFormula(index)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative', display: 'flex', width: width*0.6,height:STATIC.calSize(40, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                        <div style={{fontSize:fNormal}}>{f.name}</div>
                      </ButtonBase>

                    </Grid>)
                  })}




                  </Grid>
              </fieldset>:false}
              {showChild?<fieldset style={{ borderColor: 'white', borderRadius: 10 }}>
                <legend style={{ margin: '0px auto', padding: '2px 5px', fontSize: fTitle, color: 'rgb(5, 63, 34)' }}>{formulars[fIndex].name}</legend>
                  <Grid container direction='column' alignItems="center" justify="center" style={{paddingTop:STATIC.calSize(20, STATIC.DWIDTH, width),paddingBottom:STATIC.calSize(20, STATIC.DWIDTH, width) }} >
                    {showChild.map((f,index)=>{
                      return (<Grid key={index} item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                        <ButtonBase onClick={()=>this.selectChildFormula(index)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative', display: 'flex', width: width*0.6,height:STATIC.calSize(40, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                          <div style={{fontSize:fNormal}}>{f.name}</div>
                        </ButtonBase>

                      </Grid>)
                    })}




                    </Grid>
                </fieldset>:false}
            </div>
          </Modal>
          <Modal styles={{ modal: { minWidth: width2 * 0.8, background: 'none', boxShadow: 'none', color: showGroup.group==5?"#053F22":"#FFF200" } }} showCloseIcon={false} focusTrapped={false} open={showGroup} onClose={() => this.setState({ showGroup: false,showFText:false })} center>
            <div style={{ width: width2 * 0.8, backgroundColor: !showFText?'white':'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width2), padding: STATIC.calSize(10, STATIC.DWIDTH, width2) }}>
              <div style={{ width: width2 * 0.8 - STATIC.calSize(10, STATIC.DWIDTH, width2) * 2, borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width2), border: !showFText?'1px solid rgba(101, 163, 67, 1)':'1px solid white', textAlign: 'center' }}>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <ButtonBase
                    focusRipple

                    style={{ width: width2 * 0.1, height: width2 * 0.1, borderRadius: width2 * 0.1 / 2, backgroundColor:showGroup.group==5||showFText?'white':"#053F22",border: '1px solid rgba(101, 163, 67, 1)', cursor: 'pointer', display: 'block',marginTop: (width2 * 0.1 / 2)*-1 }}>
                    <div style={{ marginLeft: STATIC.calSize(3, STATIC.DWIDTH, width2), border: '3px solid rgba(101, 163, 67, 1)', width: width2 * 0.1-2 - STATIC.calSize(3, STATIC.DWIDTH, width2) * 2, height: width2 * 0.1-2 - STATIC.calSize(3, STATIC.DWIDTH, width2) * 2, borderRadius: (width2 * 0.1 -2 - STATIC.calSize(3, STATIC.DWIDTH, width2) * 2) / 2,
                    display:'flex',justifyContent:'center',alignItems:'center' }}>
                      {!showFText?<div style={{fontSize:fLarge}}>{showGroup.group}</div>:<img  src={'assets/images/finger/'+showGroup.group+'.png'} style={{width:STATIC.calSize(30, STATIC.DWIDTH, width2)}} />}
                    </div>

                  </ButtonBase>
                </div>
                {!showFText?<Grid container direction="row" alignItems="center" justify="center" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width2),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width2)}} >
                  <Grid item xs={5}>
                    {this.generateImages(showGroup.number,showGroup.group==5?2:5,STATIC.calSize(showGroup.group==5?50:30, STATIC.DWIDTH, width2),showGroup.group==5?'icon_apple.png':'icon_egg.png')}

                  </Grid>
                  <Grid item xs={2}>

                  </Grid>
                  <Grid item xs={5}>
                  {this.generateImages(showGroup.group-showGroup.number,showGroup.group==5?2:5,STATIC.calSize(showGroup.group==5?50:30, STATIC.DWIDTH, width2),showGroup.group==5?'icon_apple.png':'icon_egg.png')}

                  </Grid>
                </Grid>:false}
                {!showFText?<Grid container direction="row" alignItems="center" justify="center" style={{marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width2)}} >
                  <Grid item xs={5} style={{display:'flex',justifyContent:'center'}}>
                    <div style={{display:'flex',backgroundColor:showGroup.group==5?'white':"#053F22",justifyContent:'center',alignItems:'center',border: '1px solid rgba(101, 163, 67, 1)',width:STATIC.calSize(50, STATIC.DWIDTH, width2),height:STATIC.calSize(50, STATIC.DWIDTH, width2),borderRadius:STATIC.calSize(50, STATIC.DWIDTH, width2)/2}}>
                    <div style={{fontSize:fLarge}}>{showGroup.number}</div>
                    </div>
                  </Grid>
                  <Grid item xs={2} style={{color:"#053F22"}}>
                    Cặp
                  </Grid>
                  <Grid item xs={5} style={{display:'flex',justifyContent:'center'}}>
                    <div style={{display:'flex',backgroundColor:showGroup.group==5?'white':"#053F22",justifyContent:'center',alignItems:'center',border: '1px solid rgba(101, 163, 67, 1)',width:STATIC.calSize(50, STATIC.DWIDTH, width2),height:STATIC.calSize(50, STATIC.DWIDTH, width2),borderRadius:STATIC.calSize(50, STATIC.DWIDTH, width2)/2}}>
                    <div style={{fontSize:fLarge}}>{showGroup.group-showGroup.number}</div>
                    </div>
                  </Grid>
                </Grid>:false}
                {
                  showFText?<Grid container direction="column" alignItems="center" justify="center" style={{marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width2)}} >

                      {fTextList[showFText].map((f,index)=>{
                        return (<Grid item key={index} style={{color:'white',fontSize:fLarge}}>{f}</Grid>)
                      })}

                  </Grid>:false
                }





              </div>
            </div>
            <Grid container direction="row" alignItems="center" justify="center" style={{marginTop:STATIC.calSize(40, STATIC.DWIDTH, width2)}} >
              <Grid item>
            <Button onClick={()=>this.skipInGroup(showGroup.type)} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width2), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width2) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width2) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fNormal, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
              {t('common.skip')}
                                              </Button>
              </Grid>
            </Grid>

            <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
              <img
                src="assets/web/logo_green.png"
                style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
            </div>

          </Modal>
          <Modal styles={{ modal: { minWidth: width * 0.8, background: 'white',textAlign:'center' } }} open={showResultDetail} onClose={() => this.setState({ showResultDetail: false })} center>
            <div>
                  <Grid container direction="row" style={{marginTop:STATIC.calSize(40, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}} >
                    <Grid item xs={1} >
                      <div style={{fontSize: fSmall}}>{t('common.id')}</div>
                    </Grid>
                    <Grid item xs={5} >
                      <div style={{fontSize: fSmall,textAlign:'left'}}>{t('common.question')}</div>

                    </Grid>
                    <Grid item xs={2} >
                      <div style={{fontSize: fSmall}}>{t('common.input')}</div>
                    </Grid>
                    <Grid item xs={2} >
                      <div style={{fontSize: fSmall}}>{t('common.correct')}</div>

                    </Grid>
                    <Grid item xs={2} >
                      <div style={{fontSize: fSmall}}>{t('common.result')}</div>
                    </Grid>
                  </Grid>
                  <Divider />
                  {result&&result.questions?result.questions.map((q,index)=>{
                    return (<Grid key={index} container direction="row" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width)}} >
                        <Grid item xs={1} >
                          <div style={{fontSize: fSmall}}>{index+1}</div>
                        </Grid>
                        <Grid item xs={5} >
                          <div style={{fontSize: fSmall,textAlign:'left'}}>{this.getQuestionEQ(q,width)} =</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{q.answer}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{q.result}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fNormal,color:q.status==1?'green':"red"}}>{q.status==1?<CheckIcon style={{fontSize:fNormal}}/>:"X"}</div>
                        </Grid>
                    </Grid>)
                  }):false}
                  <Divider />
                  <div style={{textAlign: 'right', fontSize: fSmall, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{t('common.total')}: {result.countCorrect}/{result.qlength}<br />({result.percent}%)</div>
                <div style={{textAlign: 'left', marginTop: STATIC.calSize(40, STATIC.DWIDTH, width)}}>
                  <img
                  src="assets/web/logo_green.png"
                  style={{width: width*0.2, maxWidth: 296, height: 'auto'}} />
                  </div>

            </div>
          </Modal>


      </div>
    );
  }
}


Lessons.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Lessons));
